import axios from 'axios'

const state = {
  data: null,
  createdPage: null
}

const actions = {
  async load ({ commit }) {
    try {
      const { data } = await axios.get('/api/pages')
      commit('set', data.data)
      return data.data
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

const mutations = {
  set (state, data) {
    state.data = data
  },
  setCreatedPage (state, page) {
    state.createdPage = page
  }
}

export default {
  state,
  actions,
  mutations,
  namespaced: true
}
